// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33UaE","question":"styles_question__1QD2I","description":"styles_description__1beKT"};